import CONFIG from 'isomorphic-config'
import { LOCATION_SEARCH_TYPE } from '@/types'
import analytics from '@/shared-utils/analytics'

export type LocationSearchTypeWithNearbyAirports = LOCATION_SEARCH_TYPE & {
  nearbyAirports: LOCATION_SEARCH_TYPE[]
}

export function getAirportInfo(
  item: LocationSearchTypeWithNearbyAirports
): LocationSearchTypeWithNearbyAirports | LOCATION_SEARCH_TYPE | null {
  if (item.type === 'AIRPORT') {
    return item
  }
  if (
    (item.type === 'HOTEL_CITY' || item.type === 'CITY') &&
    item.nearbyAirports.length >= 1
  ) {
    return { ...item.nearbyAirports[0], cityName: item.displayName }
  }
  return null
}
function isLocationSearchTypeWithNearbyAirportsArray(
  data: LocationSearchTypeWithNearbyAirports[]
): data is LocationSearchTypeWithNearbyAirports[] {
  if (!Array.isArray(data)) {
    return false
  }

  return data.every(
    item => typeof item === 'object' && item !== null && 'type' in item
  )
}

export async function fetchNearbyAirports(searchValue: string) {
  const locationConfig = CONFIG.client.typeahead.location
  const url = `${locationConfig.endpoint.flightsNearbyAirport}?queryText=${searchValue}${locationConfig.querystring.flightsNearbyAirport}`
  let typeaheadRes: LocationSearchTypeWithNearbyAirports[] = []
  await fetch(url)
    .then(res => res.json())
    .then(({ matchedRegions = [] }) => {
      if (isLocationSearchTypeWithNearbyAirportsArray(matchedRegions)) {
        const isResAirportsOnly = matchedRegions.every(
          (item: { type: string }) => item.type === 'AIRPORT'
        )
        const isCityAndAirportsRes =
          matchedRegions.some(
            (item: { type: string }) => item.type === 'AIRPORT'
          ) &&
          matchedRegions.some(
            (item: { type: string }) =>
              item.type === 'CITY' || item.type === 'HOTEL_CITY'
          )
        if (isResAirportsOnly) {
          typeaheadRes = matchedRegions
          return typeaheadRes
        }
        if (isCityAndAirportsRes) {
          const newRes:
            | LocationSearchTypeWithNearbyAirports[] & LOCATION_SEARCH_TYPE[] =
            []
          matchedRegions.forEach(item => {
            if (item !== null && item !== undefined) {
              const airportInfo = getAirportInfo(item)
              if (airportInfo !== null) {
                newRes.push(airportInfo)
              }
            }
          })
          typeaheadRes = newRes
          return typeaheadRes
        }
        typeaheadRes = matchedRegions[0].nearbyAirports.map(item => ({
          ...item,
          cityName: matchedRegions[0].displayName,
          nearbyAirports: matchedRegions[0].nearbyAirports
        }))
        return typeaheadRes
      }
    })
    .catch((e: Error) => {
      analytics.logError({
        message: `Error in FlightsNearbyAirportsSeti: ${e.message}`
      })
      return null
    })
  return typeaheadRes
}
